import {
  TabsTrigger as OriginalTabsTrigger,
  type TabsTriggerProps,
  cn,
} from '@sr/ui-library-original';

/**
 * ui-library TabsTrigger with the app's compact sizing baked in as the
 * default, so consumers no longer need to copy-paste it per instance.
 */
export const TabsTrigger = ({ className, ...props }: TabsTriggerProps) => (
  <OriginalTabsTrigger
    className={cn('w-fit shrink-0 gap-1.5 px-2 text-xs', className)}
    {...props}
  />
);

export { type TabsTriggerProps };
